import { render, staticRenderFns } from "./ViewerImages.vue?vue&type=template&id=be067676&scoped=true"
import script from "./ViewerImages.vue?vue&type=script&lang=js"
export * from "./ViewerImages.vue?vue&type=script&lang=js"
import style0 from "./ViewerImages.vue?vue&type=style&index=0&id=be067676&prod&lang=css"
import style1 from "./ViewerImages.vue?vue&type=style&index=1&id=be067676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be067676",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SsrCarousel: require('/app/node_modules/vue-ssr-carousel/index.js').default,ModalVideo: require('/app/components/ModalVideo.vue').default})
